import others from './others'

export default [...others]
